import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b68ef66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EmployeesActions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "xxl",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message-bold": "Вы действительно хотите удалить?",
    "confirm-message": "После удаления сотрудника вы не сможете восстановить его обратно",
    "is-confirm": _ctx.isDelete,
    loading: _ctx.employee_state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_the_input, {
          placeholder: "Сотрудник",
          "is-invalid": _ctx.state_form$.fullName.$error,
          "validation-errors": _ctx.state_form$.fullName.$errors,
          value: _ctx.state.fullName,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.fullName) = $event))
        }, null, 8, ["is-invalid", "validation-errors", "value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Организация",
          "is-invalid": _ctx.state_form$.organizationId.$error,
          "validation-errors": _ctx.state_form$.organizationId.$errors,
          loading: _ctx.data_state.organizations.is_loading,
          failed: _ctx.data_state.organizations.is_failed,
          options: _ctx.data_state.organizations.list,
          "error-text": "При получении списка организаций произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.organizationId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.organizationId) = $event)),
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadDictionary(3))),
          onSearch: _ctx.searchDictionaryThree
        }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Отдел",
          "is-invalid": _ctx.state_form$.departmentId.$error,
          "validation-errors": _ctx.state_form$.departmentId.$errors,
          loading: _ctx.data_state.departments.is_loading,
          failed: _ctx.data_state.departments.is_failed,
          options: _ctx.data_state.departments.list,
          "error-text": "При получении списка отделов произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.departmentId,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.departmentId) = $event)),
          onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadDictionary(1))),
          onSearch: _ctx.searchDictionaryOne
        }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Подразделение",
          "is-invalid": _ctx.state_form$.subdivisionId.$error,
          "validation-errors": _ctx.state_form$.subdivisionId.$errors,
          loading: _ctx.data_state.subdivisions.is_loading,
          failed: _ctx.data_state.subdivisions.is_failed,
          options: _ctx.data_state.subdivisions.list,
          "error-text": "При получении списка подразделений произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.subdivisionId,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.subdivisionId) = $event)),
          onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadDictionary(5))),
          onSearch: _ctx.searchDictionary
        }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата приема",
          "is-invalid": _ctx.state_form$.dateOfReceipt.$error,
          "validation-errors": _ctx.state_form$.dateOfReceipt.$errors,
          value: _ctx.state.dateOfReceipt,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.dateOfReceipt) = $event)),
          type: "date"
        }, null, 8, ["is-invalid", "validation-errors", "value"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата рождения",
          "is-invalid": _ctx.state_form$.dateOfBirth.$error,
          "validation-errors": _ctx.state_form$.dateOfBirth.$errors,
          value: _ctx.state.dateOfBirth,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.dateOfBirth) = $event)),
          type: "date"
        }, null, 8, ["is-invalid", "validation-errors", "value"]),
        _createVNode(_component_the_input, {
          placeholder: "E-mail адрес",
          value: _ctx.state.email,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.email) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Мобильный телефон",
          "is-invalid": _ctx.state_form$.phoneNumber.$error,
          "validation-errors": _ctx.state_form$.phoneNumber.$errors,
          value: _ctx.state.phoneNumber,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.phoneNumber) = $event)),
          maska: _ctx.PHONE_NUMBER_MASK
        }, null, 8, ["is-invalid", "validation-errors", "value", "maska"]),
        _createVNode(_component_the_input, {
          placeholder: "Рабочий телефон",
          value: _ctx.state.workPhone,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.workPhone) = $event)),
          maska: _ctx.PHONE_NUMBER_MASK
        }, null, 8, ["value", "maska"]),
        _createVNode(_component_the_select, {
          placeholder: "Город",
          "is-invalid": _ctx.state_form$.cityId.$error,
          "validation-errors": _ctx.state_form$.cityId.$errors,
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          options: _ctx.data_state.cities.list,
          "error-text": "При получении списка городов произошла ошибка",
          "infinite-scroll": "",
          value: _ctx.state.cityId,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.cityId) = $event)),
          onRefresh: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
          onLoadmore: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
          onSearch: _ctx.searchCity,
          onOptionBySearch: _ctx.unshiftFindedCity
        }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          placeholder: "Должность",
          "is-invalid": _ctx.state_form$.jobId.$error,
          "validation-errors": _ctx.state_form$.jobId.$errors,
          loading: _ctx.data_state.jobs.is_loading,
          failed: _ctx.data_state.jobs.is_failed,
          options: _ctx.data_state.jobs.list,
          "error-text": "При получении списка должностей произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.jobId,
          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.jobId) = $event)),
          onRefresh: _cache[16] || (_cache[16] = ($event: any) => (_ctx.loadDictionary(2))),
          onSearch: _ctx.searchDictionaryTwo
        }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch"]),
        _createVNode(_component_the_select, {
          placeholder: "Состояние",
          "is-invalid": _ctx.state_form$.statusId.$error,
          "validation-errors": _ctx.state_form$.statusId.$errors,
          loading: _ctx.data_state.statuses.is_loading,
          failed: _ctx.data_state.statuses.is_failed,
          options: _ctx.data_state.statuses.list,
          "error-text": "При получении списка состояний произошла ошибка",
          label: "description",
          "infinite-scroll": "",
          value: _ctx.state.statusId,
          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.statusId) = $event)),
          onRefresh: _cache[18] || (_cache[18] = ($event: any) => (_ctx.loadDictionary(4))),
          onSearch: _ctx.searchDictionaryFour
        }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch"])
      ])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "is-confirm", "loading", "onCancel", "onConfirm"]))
}